import styled from "styled-components";
import { Alert } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ContentCard } from "../../component/admin";
import BoardTab from "../../component/category/BoardTab";

const CategoryManagePage = () => {
  return (
    <ContentCard>
      <AdminInfoBox>
        <Alert
          message="카테고리 편집 안내"
          description="카테고리 수정/삭제는 해당 카테고리 메뉴에 우클릭, 게시글 이동은 이동하고자 하는 게시글에 우클릭을 이용해주세요. 게시글 여러개 선택시 ctrl+좌클릭 이용해주세요."
          type="info"
          showIcon
          icon={<InfoCircleOutlined />}
          closable
        />
      </AdminInfoBox>
      <BoardTab />
    </ContentCard>
  )
};

const AdminInfoBox = styled.div`
  margin-bottom: 24px;
  
  .ant-alert-info {
    background-color: #f0f7ff;
    border: 1px solid #adc6ff;
    border-radius: 8px;
  }
  
  .ant-alert-message {
    font-weight: bold;
    color: #1d39c4;
  }

  .ant-alert-description {
    color: #262626;
    font-size: 14px;
  }
`;

export default CategoryManagePage;